// LinkedIn OAuth konfiguration
export const linkedInConfig = {
  clientId: process.env.REACT_APP_LINKEDIN_CLIENT_ID,
  clientSecret: process.env.REACT_APP_LINKEDIN_CLIENT_SECRET,
  scope: 'openid profile email w_member_social',
  authorizeEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
  tokenEndpoint: 'https://www.linkedin.com/oauth/v2/accessToken',
  apiBaseUrl: 'https://api.linkedin.com/v2'
};

// Miljøkonfiguration
export const environment = {
  isDevelopment: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1',
  isProduction: window.location.hostname === 'app-nuvik.web.app' || window.location.hostname === 'app.nuvik.io' || window.location.hostname === 'test.app.nuvik.io',
  
  // Dynamisk baseUrl baseret på det aktuelle domæne
  get baseUrl() {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:3000';
    } else if (hostname === 'app-nuvik.web.app') {
      return 'https://app-nuvik.web.app';
    } else if (hostname === 'app.nuvik.io') {
      return 'https://app.nuvik.io';
    } else if (hostname === 'test.app.nuvik.io') {
      return 'https://test.app.nuvik.io';
    } else {
      // Fallback
      return process.env.REACT_APP_FRONTEND_URL || 'https://app.nuvik.io';
    }
  }
};

// API-nøgler
export const apiKeys = {
  openAI: process.env.REACT_APP_OPENAI_API_KEY,
  claude: process.env.REACT_APP_CLAUDE_API_KEY
};

// Telegram konfiguration
export const telegramConfig = {
  botToken: process.env.REACT_APP_TELEGRAM_BOT_TOKEN
};

// Firebase konfiguration
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};